import {Injectable} from '@angular/core';
import {Observable} from 'rxjs/Observable';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import Api from '../../common/services/api.service';

const httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json', 'Access-Control-Allow-Origin': '*' })
};

@Injectable()
export class AuthService {

    
    //serviceUrl = '/sonavie/token';
    serviceUrl = 'token';

    constructor(private api: Api) { }

    attemptAuth(login: string, password: string): Observable<any> {
        const credentials = {login: login, pwd: password};
        const respo = this.api.post(this.serviceUrl, credentials); 
       ////console.log("Reponse perso: " + respo);
        return  respo
    }

}



// WEBPACK FOOTER //
// ./src/app/admin-app/services/auth.service.ts